import { Box, Checkbox, FormControlLabel, Stack } from "@mui/material";
import { MaterialInventoriesPermission } from "commons/enum/permission";
import { Dayjs } from "dayjs";
import { observer } from "mobx-react-lite";
import { useStores } from "mobx-stores/_root-store";
import { useCallback } from "react";
import { DateRange } from "share-components/atomics/date-range";
import { AddButton } from "share-components/mui-wrap/button/action-button";
import { SearchButton } from "share-components/mui-wrap/button/search-button";
import { PageContentContainer } from "share-components/templates/page/page-content-container";
import { PageFilterContainer } from "share-components/templates/page/page-filter-container";
import { AddMaterialGoodsReceipt } from "../add-goods-receipt/add-goods-receipt";
import { MaterialGroupSelectionConnected } from "../shared-components";
import { UpdateMaterialGoodsReceipt } from "../update-goods-receipt/update-goods-receipt";
import { MaterialGoodsReceiptTable } from "./material-goods-reciept-table";

export const MaterialGoodsReceiptList = observer(() => {
  const {
    materialInventoryManagement: {
      materialGoodsReceiptStore: {
        setProp,
        pagination,
        getMaterialGoodsReceipt,
        openNew,
        openEdit,
        queryParams: {
          dateRangeFilter: {
            fromAsDayJs,
            toAsDayJs,
            setProp: setDateRangeProps,
          },
          code,
          name,
          type,
          barcode,
          showZeroQuantity,
          setProp: setQueryParamProp,
        },
      },
    },
  } = useStores();
  const onSearch = useCallback(async () => {
    pagination.setProp("pageIndex", 0);
    await getMaterialGoodsReceipt();
  }, [getMaterialGoodsReceipt, pagination]);

  const fromDateChangedHandler = useCallback(
    (value?: Dayjs | null) => {
      setDateRangeProps("from", value ? value.toString() : null);
    },
    [setDateRangeProps],
  );

  const toDateChangedHandler = useCallback(
    (value?: Dayjs | null) => {
      setDateRangeProps("to", value ? value.toString() : null);
    },
    [setDateRangeProps],
  );

  const showZeroQuantityHandler = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => {
      setQueryParamProp("showZeroQuantity", checked);
      getMaterialGoodsReceipt();
    },
    [getMaterialGoodsReceipt, setQueryParamProp],
  );

  return (
    <>
      <Stack direction="row" justifyContent="space-between" alignItems="end">
        <Stack direction="column" gap={1}>
          <PageFilterContainer>
            <DateRange
              label={"Ngày nhập"}
              fromDate={fromAsDayJs}
              toDate={toAsDayJs}
              onFromDateChanged={fromDateChangedHandler}
              onToDateChanged={toDateChangedHandler}
            ></DateRange>
          </PageFilterContainer>
          <PageFilterContainer>
            <MaterialGroupSelectionConnected
              codeSelected={code}
              typeSelected={type}
              nameSelected={name}
              barcodeSelected={barcode}
              setSelectionProp={setQueryParamProp}
            ></MaterialGroupSelectionConnected>
            <SearchButton asyncAction={onSearch}></SearchButton>
          </PageFilterContainer>
        </Stack>
        <Box flexShrink={0}>
          <AddButton
            accessPermission={[MaterialInventoriesPermission.ReceiptCreate]}
            onClick={() => {
              setProp("openNew", true);
            }}
          >
            Thêm nhập kho
          </AddButton>
        </Box>
      </Stack>
      <Stack
        direction={"row"}
        justifyContent={"right"}
        sx={{ marginTop: "10px" }}
        spacing={1}
      >
        <FormControlLabel
          control={
            <Checkbox
              checked={showZeroQuantity}
              onChange={showZeroQuantityHandler}
            />
          }
          label="Gồm tồn bằng 0"
        />
      </Stack>
      <PageContentContainer sx={{ marginTop: "10px" }}>
        <MaterialGoodsReceiptTable></MaterialGoodsReceiptTable>
      </PageContentContainer>

      <>
        <>{openNew && <AddMaterialGoodsReceipt></AddMaterialGoodsReceipt>}</>
        <>
          {openEdit && (
            <UpdateMaterialGoodsReceipt></UpdateMaterialGoodsReceipt>
          )}
        </>
      </>
    </>
  );
});
